function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _require = require('leaflet-geosearch'),
  OpenStreetMapProvider = _require.OpenStreetMapProvider;
var CustomOSMProvider = /*#__PURE__*/function (_OpenStreetMapProvide) {
  function CustomOSMProvider() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CustomOSMProvider);
    _this = _callSuper(this, CustomOSMProvider, [options]);
    var host = 'https://nominatim.openstreetmap.org';
    _this.searchUrl = options.searchUrl || "".concat(host, "/search");
    _this.reverseUrl = options.reverseUrl || "".concat(host, "/reverse");
    return _this;
  }
  _inherits(CustomOSMProvider, _OpenStreetMapProvide);
  return _createClass(CustomOSMProvider, [{
    key: "endpoint",
    value: function endpoint(_ref) {
      var query = _ref.query,
        type = _ref.type,
        country = _ref.country,
        postalcode = _ref.postalcode;
      var params = typeof query === 'string' ? {
        q: query
      } : query;
      params.format = 'jsonv2';
      params.countrycodes = country;
      params.postalcode = postalcode;
      switch (type) {
        // RequestType.REVERSE === 1
        case 1:
          return this.getUrl(this.reverseUrl, params);
        default:
          return this.getUrl(this.searchUrl, params);
      }
    }
  }, {
    key: "parse",
    value: function parse(response) {
      var records = Array.isArray(response.data) ? response.data : [response.data];
      return records.map(function (r) {
        return {
          x: Number(r.lon),
          y: Number(r.lat),
          label: r.display_name,
          bounds: [[parseFloat(r.boundingbox[0]), parseFloat(r.boundingbox[2])],
          // s, w
          [parseFloat(r.boundingbox[1]), parseFloat(r.boundingbox[3])] // n, e
          ],
          raw: r
        };
      });
    }
  }, {
    key: "getParamString",
    value: function getParamString() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var set = Object.assign({}, this.options.params, params);
      return Object.keys(set).filter(function (key) {
        return !!set[key];
      }).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(set[key]));
      }).join('&');
    }
  }, {
    key: "getUrl",
    value: function getUrl(url, params) {
      return "".concat(url, "?").concat(this.getParamString(params));
    }
  }, {
    key: "search",
    value: function search(options) {
      var _this2 = this;
      return new Promise(function (resolve) {
        var url = _this2.endpoint({
          query: options.query,
          // RequestType.SEARCH === 0
          type: 0,
          country: options.country,
          postalcode: options.postalcode
        });
        return resolve(fetch(url));
      }).then(function (request) {
        return request.json();
      }).then(function (json) {
        return _this2.parse({
          data: json
        });
      });
      ;
    }
  }]);
}(OpenStreetMapProvider);
module.exports = CustomOSMProvider;